export default "__VITE_ASSET__CgmYDtWd__"